import { useAppActions } from 'reducers/slices/appSlice';
import { useFetchStatus } from 'utils/fetchStatusUtils';
import { useSelector } from 'react-redux';

export default () => {
  const {
    signUp,
    logout,
    login,
    updatePassword,
    updateBuyer,
    loadCurrentUser,
    updateLoanOfficer,
    saveProfileImage,
    saveCompanyLogo,
    saveProfileVideo,
    updateRealEstateAgent,
    loginWithGoogle,
  } = useAppActions();

  const {
    loading,
    error,
    currentUser,
    loggingInStatus,
    userRegistrationStatus,
    currentUserLoadingStatus,
    updatingStatus,
    passwordUpdatingStatus,
    profileCompanyLogoSavingStatus,
    profileImageSavingStatus,
  } = useSelector(state => state.appSlice);

  return {
    signUp,
    logout,
    login,
    loading,
    error,
    updatePassword,
    loginWithGoogle,
    updateBuyer,
    isUpdating: useFetchStatus(updatingStatus).isPending,
    isPasswordUpdating: useFetchStatus(passwordUpdatingStatus).isPending,
    loadCurrentUser,
    currentUser,
    isCurrentUserLoading: useFetchStatus(currentUserLoadingStatus).isPending,
    isCurrentUserIdle: useFetchStatus(currentUserLoadingStatus).isIdle,
    updateLoanOfficer,
    saveProfileImage,
    saveCompanyLogo,
    saveProfileVideo,
    updateRealEstateAgent,
    isLoggingIn: useFetchStatus(loggingInStatus).isPending,
    isSigningUp: useFetchStatus(userRegistrationStatus).isPending,
    isProfileImageSaving: useFetchStatus(profileImageSavingStatus).isPending,
    isProfileCompanyLogoSaving: useFetchStatus(profileCompanyLogoSavingStatus).isPending,
  };
};



// WEBPACK FOOTER //
// ./src/reducers/hooks/useApp.js